import {DateRangeInput} from "../../../general/DateRangeInput/DateRangeInput.tsx";
import {DateRangePreset} from "../../../general/DateRangeInput/constants.ts";
import {
    formatDateForInput,
    parseDate,
} from "../../../general/DateRangeInput/utils/dateRangeUtils.ts";
import {fieldLabelClasses} from "../../../general/fieldStyles.ts";

interface PeriodDateRangeFieldProps {
    dateFrom: string;
    dateTo: string;
    onChange: (from: string, to: string) => void;
}

export function PeriodDateRangeField({dateFrom, dateTo, onChange}: PeriodDateRangeFieldProps) {
    return (
        <div className="flex flex-col gap-1.5">
            <span className={fieldLabelClasses}>Periode</span>
            <div className="w-[234px]">
                <DateRangeInput
                    value={{from: parseDate(dateFrom), to: parseDate(dateTo)}}
                    defaultPreset={DateRangePreset.ThisYear}
                    onChange={(range) => {
                        onChange(formatDateForInput(range.from), formatDateForInput(range.to));
                    }}
                />
            </div>
        </div>
    );
}
